import { Card } from '@/components/ui/card';
import { BarChart } from '@/features/dashboard-charts';
import type { TopItemsData } from '@/entities/dashboard';

interface TopListsGridProps {
  topTransporters?: TopItemsData;
  topTransportUsers?: TopItemsData;
  isLoading: boolean;
}

export function TopListsGrid({ topTransporters, topTransportUsers, isLoading }: TopListsGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Top Transporters</h3>
        <BarChart data={topTransporters} height={300} loading={isLoading} />
      </Card>

      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Top Transport Users</h3>
        <BarChart data={topTransportUsers} height={300} loading={isLoading} />
      </Card>
    </div>
  );
}
